import React, { useState, useRef, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import CustomInput from "../../../Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import { Form, Label } from "reactstrap";
import { Row, Col, Modal, Accordion } from "react-bootstrap";
import CustomFlatpickr from "../../../Custom/CustomFlatpicker";
import CustomSelect from "../../../Custom/CustomSelect";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
const ActivityMonitoring = () => {
  const [activeDefault, setActiveDefault] = useState(0);
  const [orderDetailModal, setOrderDetailModal] = useState(false);
  const [staffChangeModal, setStaffChangeModal] = useState(false);
  const [patientDetailModal, setPatientDetailModal] = useState(false);
  const [selectStartTime, handleChangeStartTime] = useState(new Date());
  const [selectEndTime, handleChangeEndTime] = useState(new Date());
  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      Date: new Date(),
    },
    validateOnBlur: false,
  });
  const { handleValidSubmitFilter } = formikFilter;

  const validationSchemaStaffChange = Yup.object().shape({
    StaffID: Yup.string().required("Staff Name is required field"),
    Date: Yup.string().required("Date is required field"),
    StartTime: Yup.string().required("Start Time is required field"),
    EndTime: Yup.string().required("End Time is required field"),
  });

  const formikStaffChange = useFormik({
    validationSchema: validationSchemaStaffChange,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitStaffChange(values, formikHelpers),
    initialValues: {
      StaffID: "",
      StartTime: "",
      EndTime: "",
      Date: "",
    },
    validateOnBlur: false,
  });
  const { setValues, setFieldValue, handleValidSubmitStaffChange } =
    formikStaffChange;

  const optionStaff = [
    { label: "Yana Suthar", value: 1 },
    { label: "Nilesh Soni", value: 2 },
    { label: "Nishit Kachiya", value: 3 },
    { label: "Chirag Suthar", value: 4 },
  ];
  return (
    <>
      <Fragment>
        <PageTitle motherMenu="Transaction" activeMenu="Acitvity Monitoring" />

        <Row className="mb-3">
          <Col lg={12}>
            <Accordion
              className="accordion accordion-no-gutter accordion-header-bg"
              defaultActiveKey={0}
            >
              <div className="accordion__item" key={1}>
                <Accordion.Toggle
                  eventKey={1}
                  className={`accordion__header  ${
                    activeDefault === 1 ? "" : "collapsed"
                  }`}
                  style={{
                    minWidth: "100%",
                  }}
                  onClick={() => setActiveDefault(activeDefault === 1 ? -1 : 1)}
                >
                  <span
                    className="accordion__header--text"
                    style={{ float: "left" }}
                  >
                    <i
                      class="fa fa-filter"
                      aria-hidden="true"
                      style={{ fontSize: "20px" }}
                    ></i>
                    &nbsp;
                    {"Filter"}
                  </span>
                  <span className="accordion__header--indicator"></span>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={1}>
                  <div className="accordion__body--text">
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row>
                          <Col lg={2}>
                            <Field
                              name="Date"
                              placeholder={"Select Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                          </Col>
                          <Col lg={4}>
                            <label></label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  to="#"
                                  className="btn btn-primary btn-xs btn-rounded"
                                >
                                  Search
                                </Link>
                              </div>
                              &nbsp;
                              <div className="d-lg-block">
                                <Link
                                  to="#"
                                  className="btn btn-light btn-xs btn-rounded"
                                >
                                  Clear
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                </Accordion.Collapse>
              </div>
            </Accordion>
          </Col>
        </Row>

        <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
          <div className="input-group search-area ml-auto d-inline-flex mr-3">
            <input
              type="text"
              style={{ height: "36px" }}
              className="form-control"
              placeholder="Search here"
            />
            <div className="input-group-append">
              <button type="button" className="input-group-text">
                <i className="flaticon-381-search-2" />
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="table-responsive">
              <div
                id="AcitvityMonitoring_list"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="example5"
                  className="table table-striped AcitvityMonitoring_list mb-4 dataTablesCard fs-14 dataTable no-footer"
                  role="grid"
                  aria-describedby="example5_info"
                >
                  <thead>
                    <tr role="row">
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Sr No.: activate to sort column ascending"
                        // style={{ width: "5" }}
                      >
                        Sr No.
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Staff Name: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Staff Name
                      </th>
                      {/* <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Staff Mobile: activate to sort column ascending"
                        // style={{ width: "5" }}
                      >
                        Staff Mobile
                      </th> */}
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Apt. Start: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Apt. Start
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Apt. End: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Apt. End
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Patient Name: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Patient Name
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Area: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Area
                      </th>
                      {/* <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Mobile No.: activate to sort column ascending"
                        // style={{ width: "5" }}
                      >
                        Mobile No.
                      </th> */}
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Punch Start: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Punch Start
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Punch End: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Punch End
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Category: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Category
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Status: activate to sort column ascending"
                        // style={{ width: "5" }}
                      >
                        Status
                      </th>

                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Actions: activate to sort column ascending"
                        // style={{ width: "10" }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      className="odd"
                      style={{ backgroundColor: "#558b2f36" }}
                    >
                      <td style={{ textAlign: "center" }}>1</td>
                      <td>Yana Suthar (9638527410)</td>
                      <td>8:00 AM</td>
                      <td>10:00 AM</td>
                      <td>Nilesh Soni (9638521470)</td>
                      <td>Pragatinagar</td>
                      <td>8:00 AM</td>
                      <td>10:00 AM</td>
                      <td>Sercvice</td>
                      <td>Completed</td>
                      <td>
                        <div className="d-flex">
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Patient Detail"
                            onClick={() => {
                              setPatientDetailModal(true);
                            }}
                          >
                            <i
                              className="fa fa-info"
                              style={{ color: "#333b3d" }}
                            ></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Order Detail"
                            onClick={() => {
                              setOrderDetailModal(true);
                            }}
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Edit"
                            onClick={() => {
                              setStaffChangeModal(true);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr
                      role="row"
                      className="odd"
                      style={{ backgroundColor: "#756c9b36" }}
                    >
                      <td style={{ textAlign: "center" }}>2</td>
                      <td>Nishit Kachiya (9638527410)</td>
                      <td>9:00 AM</td>
                      <td>12:00 PM</td>
                      <td>Lalikant Kachiya (9638527410)</td>
                      <td>Bapunagar</td>
                      <td>9:00 AM</td>
                      <td>12:00 PM</td>
                      <td>Sercvice</td>
                      <td>Pending</td>
                      <td>
                        <div className="d-flex">
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Patient Detail"
                            onClick={() => {
                              setPatientDetailModal(true);
                            }}
                          >
                            <i
                              className="fa fa-info"
                              style={{ color: "#333b3d" }}
                            ></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Order Detail"
                            onClick={() => {
                              setOrderDetailModal(true);
                            }}
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Edit"
                            onClick={() => {
                              setStaffChangeModal(true);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr
                      role="row"
                      className="odd"
                      style={{ backgroundColor: "#ff8f1530" }}
                    >
                      <td style={{ textAlign: "center" }}>3</td>
                      <td>Chirag Suthar (9638527410)</td>
                      <td>5:00 PM</td>
                      <td>10:00 PM</td>
                      <td>Nimit Suthar (9638527410)</td>
                      <td>Vastral</td>
                      <td>5:00 PM</td>
                      <td>10:00 PM</td>
                      <td>Sercvice</td>
                      <td>On Leave</td>
                      <td>
                        <div className="d-flex">
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Patient Detail"
                            onClick={() => {
                              setPatientDetailModal(true);
                            }}
                          >
                            <i
                              className="fa fa-info"
                              style={{ color: "#333b3d" }}
                            ></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Order Detail"
                            onClick={() => {
                              setOrderDetailModal(true);
                            }}
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Edit"
                            onClick={() => {
                              setStaffChangeModal(true);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr
                      role="row"
                      className="odd"
                      style={{ backgroundColor: "#2081e338" }}
                    >
                      <td style={{ textAlign: "center" }}>4</td>
                      <td>Nirav Savaliya (9638527410)</td>
                      <td>9:30 AM</td>
                      <td>12:30 PM</td>
                      <td>Khemu Savaliya (9638527410)</td>
                      <td>South Bopal</td>
                      <td>9:30 AM</td>
                      <td>1:00 PM</td>
                      <td>Sercvice</td>
                      <td>Rescheduled</td>
                      <td>
                        <div className="d-flex">
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Patient Detail"
                            onClick={() => {
                              setPatientDetailModal(true);
                            }}
                          >
                            <i
                              className="fa fa-info"
                              style={{ color: "#333b3d" }}
                            ></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Order Detail"
                            onClick={() => {
                              setOrderDetailModal(true);
                            }}
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Edit"
                            onClick={() => {
                              setStaffChangeModal(true);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr
                      role="row"
                      className="odd"
                      style={{ backgroundColor: "#c628282e" }}
                    >
                      <td style={{ textAlign: "center" }}>5</td>
                      <td>Hitesh Vaghela (9638527410)</td>
                      <td>2:45 PM</td>
                      <td>5:45 PM</td>
                      <td>Urmesh Vaghela (9638527410)</td>
                      <td>Gota</td>
                      <td>2:00 PM</td>
                      <td>6:00 PM</td>
                      <td>Sercvice</td>
                      <td>Cancelled</td>
                      <td>
                        <div className="d-flex">
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Patient Detail"
                            onClick={() => {
                              setPatientDetailModal(true);
                            }}
                          >
                            <i
                              className="fa fa-info"
                              style={{ color: "#333b3d" }}
                            ></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Order Detail"
                            onClick={() => {
                              setOrderDetailModal(true);
                            }}
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Edit"
                            onClick={() => {
                              setStaffChangeModal(true);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                    <tr
                      role="row"
                      className="odd"
                      style={{ backgroundColor: "#558b2f36" }}
                    >
                      <td style={{ textAlign: "center" }}>6</td>
                      <td>Disha Jhala (9638527410)</td>
                      <td>9:00 AM</td>
                      <td>11:30 AM</td>
                      <td>Urvi Jhala (9638527410)</td>
                      <td>Shyamal</td>
                      <td>8:30 AM</td>
                      <td>11:30 AM</td>
                      <td>Sercvice</td>
                      <td>Completed</td>
                      <td>
                        <div className="d-flex">
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Patient Detail"
                            onClick={() => {
                              setPatientDetailModal(true);
                            }}
                          >
                            <i
                              className="fa fa-info"
                              style={{ color: "#333b3d" }}
                            ></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Order Detail"
                            onClick={() => {
                              setOrderDetailModal(true);
                            }}
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-light shadow btn-xs sharp mr-1"
                            title="Edit"
                            onClick={() => {
                              setStaffChangeModal(true);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <Modal
          className="modal fade"
          show={orderDetailModal}
          onHide={setOrderDetailModal}
          size="xl"
        >
          <div className="modal-header">
            <h4 className="modal-title fs-20">Order Detail</h4>
            <button
              type="button"
              className="btn close"
              onClick={() => setOrderDetailModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>PT00000001</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Order No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>AMDOD00002</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient Name</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Yana Suthar</Col>
                </Row>
              </Col>

              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Booking Order Date</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>17/Feb/2023</Col>
                </Row>
              </Col>

              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient Address</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5} style={{ textAlign: "left" }}>
                    A-910, Titanium City Center, Prahlad Nagar
                  </Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Mobile No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>9638869115</Col>
                </Row>
              </Col>
            </Row>
            <hr></hr>
            <Row className="mt-4">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Service Name: activate to sort column ascending"
                            style={{ width: "35%", padding: "10px 20px" }}
                          >
                            Service Name
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Quantity: activate to sort column ascending"
                            style={{
                              width: "15%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Quantity
                          </th>{" "}
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Service Book Days: activate to sort column ascending"
                            style={{
                              width: "30%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Service Book Days
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Care Giver</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 500.00
                          </td>
                        </tr>
                        <tr role="row" className="even">
                          <td>Doctor Visit</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 5000.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Equipment Name: activate to sort column ascending"
                            style={{ width: "35%", padding: "10px 20px" }}
                          >
                            Equipment Name
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Quantity: activate to sort column ascending"
                            style={{
                              width: "15%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Quantity
                          </th>{" "}
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Equipment Book Days: activate to sort column ascending"
                            style={{
                              width: "30%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Equipment Book Days
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Reclining Electric Wheelchair</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 500.00
                          </td>
                        </tr>
                        <tr role="row" className="even">
                          <td>Basic Electric Wheelchair</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 5000.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Package Name: activate to sort column ascending"
                            style={{ width: "80%", padding: "10px 20px" }}
                          >
                            Package Name
                          </th>

                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Post Knee & Hip Replacement Package</td>

                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 25500.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Health Checkup: activate to sort column ascending"
                            style={{ width: "80%", padding: "10px 20px" }}
                          >
                            Health Checkup
                          </th>

                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Cardiac Stress Analysis</td>

                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 500.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <Col lg={4}></Col>
              <Col lg={8}>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Gross Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 5000.00
                  </Col>
                  <br></br>
                </Row>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Discount Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    {" "}
                    <i class="fa fa-rupee"></i> 500.00
                  </Col>
                  <br></br>
                </Row>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Net Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 55002.00
                  </Col>
                  <br></br>
                </Row>
                <hr style={{ marginLeft: "50%" }}></hr>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Deposite Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 50.00
                  </Col>
                  <br></br>
                </Row>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Advance Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 5.00
                  </Col>
                  <br></br>
                </Row>
              </Col>
            </Row>
            <button
              style={{ float: "right" }}
              className="btn mt-5 mr-2 btn-xs btn-light"
              onClick={() => {
                setOrderDetailModal(false);
              }}
            >
              Close
            </button>
          </div>
        </Modal>
        <Modal
          className="modal fade"
          show={staffChangeModal}
          onHide={setStaffChangeModal}
        >
          <FormikProvider value={formikStaffChange}>
            <Form onSubmit={formikStaffChange.handleSubmit}>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Staff Change</h4>
                <button
                  type="button"
                  className="btn close"
                  onClick={() => setStaffChangeModal(false)}
                >
                  <span>×</span>
                </button>
              </div>
              <div className="modal-body">
                <Row>
                  <Col lg={6}>
                    <button type="button" className="btn btn-xs btn-primary">
                      Skip
                    </button>
                    &nbsp;
                    <button type="button" className="btn btn-xs btn-primary">
                      Extend
                    </button>
                  </Col>
                </Row>
                <hr></hr>
                <h4 className="ml-0">Replace Staff</h4>
                <Row className="mt-3">
                  <Col lg={8}>
                    <Field
                      label={"Date"}
                      name="Date"
                      placeholder={"Select Date"}
                      component={CustomFlatpickr}
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                      }}
                      required
                    />
                  </Col>
                  <Col lg={6}>
                    <Label>
                      Start Time
                      <span className="text-danger">*</span>
                    </Label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <TimePicker
                        autoOk
                        name={"StartTime"}
                        placeholder={"Select Start Time"}
                        value={selectStartTime}
                        onChange={handleChangeStartTime}
                      />
                    </MuiPickersUtilsProvider>
                  </Col>
                  <Col lg={6}>
                    <Label>
                      End Time
                      <span className="text-danger">*</span>
                    </Label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <TimePicker
                        name={"EndTime"}
                        autoOk
                        value={selectEndTime}
                        placeholder={"Select End Time"}
                        onChange={handleChangeEndTime}
                      />
                    </MuiPickersUtilsProvider>
                  </Col>
                  <Col lg={12}>
                    <Field
                      label={"Staff Name"}
                      name="StaffID"
                      options={optionStaff}
                      placeholder={"Select Staff Name"}
                      component={CustomSelect}
                      required
                    />
                  </Col>
                </Row>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-xs btn-primary">
                  Save
                </button>
                <button
                  type="button"
                  onClick={() => setStaffChangeModal(false)}
                  className="btn btn-xs btn-light"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Cancel
                </button>
              </div>
            </Form>
          </FormikProvider>
        </Modal>
        <Modal
          className="modal fade"
          show={patientDetailModal}
          onHide={setPatientDetailModal}
          size="lg"
        >
          <div className="modal-header">
            <h4 className="modal-title fs-20">Patient Detail</h4>
            <button
              type="button"
              className="btn close"
              onClick={() => setPatientDetailModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>PT00000001</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Order No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>AMDOD00002</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient Name</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Yana Suthar</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Client Name</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Chayan Suthar</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Gender</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Female</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Blood Group</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>A+</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Relation with Client</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Sister</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Mobile No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>9638869115</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Email ID</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>yana@gmail.com</Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => setPatientDetailModal(false)}
              className="btn btn-xs btn-light"
            >
              {" "}
              <i className="flaticon-delete-1"></i> Close
            </button>
          </div>
        </Modal>
      </Fragment>
    </>
  );
};

export default ActivityMonitoring;
